import { Inject, Injectable } from "@angular/core";

import { GLOBAL_CONFIG } from "../const";
import { GlobalConfig } from "../model";

import { Device, DeviceExperience, DeviceType } from "./device.model";

/**
 * @deprecated - [fabric-deprecated] - Use StartupContextService from svc-config instead.
 * */
@Injectable({
	providedIn: "root",
})
export class DeviceConfigService {
	private readonly device: Device = {
		deviceType: DeviceType.Desktop,
		deviceExperience: DeviceExperience.Web,
		...this.config?.device,
	};

	constructor(@Inject(GLOBAL_CONFIG) private config?: GlobalConfig) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use `ConfigServiceValue.DeviceType` instead
	 */
	getType(): DeviceType {
		return this.device.deviceType;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use `ConfigServiceValue.DeviceExperience` instead
	 */
	getExperience(): DeviceExperience {
		return this.device.deviceExperience;
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use `ConfigServiceValue.DeviceExperience` and/or `ConfigServiceValue.DeviceType` instead
	 */
	getPlatform(): DeviceExperience | DeviceType {
		return this.getExperience() === DeviceExperience.Native ? DeviceExperience.Native : this.getType();
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use `ConfigServiceValue.DeviceType` instead
	 */
	isDesktop(): boolean {
		return this.device.deviceType === DeviceType.Desktop;
	}
}
